<p-dialog [(visible)]="createRepoVisible" (onHide)="onClose()" styleClass="create-repo-dialog" appendTo="body"
  [focusOnShow]="false" [draggable]="false" [dismissableMask]="true" [modal]="true" [resizable]="false"
  [closable]="true" (onHide)="onDialogHide()" (onShow)="onCreateRepoDialogShow()">

  <ng-template #header>
    <div class="dialog-header">
      <span class="dialog-title">Connect to Repository</span>
    </div>
  </ng-template>

  <div class="dialog-content">
    <!-- Storage Type Selection -->
    <div class="storage-section">
      <h2 class="section-title">Choose your storage method</h2>

      <div class="storage-options">
        <!-- Cloud Storage Option -->
        <div class="storage-card" [class.active]="selectedRepoType === 'Cloud'" (click)="toggleButton('Cloud')">
          <div class="storage-icon cloud">
            <ng-icon name="heroCloud" size="28"></ng-icon>
          </div>
          <div class="storage-info">
            <span class="storage-label">Cloud Storage</span>
            <span class="storage-desc">Access from any device, anytime</span>
          </div>
          <div class="storage-check">
            <div class="check-circle" [class.checked]="selectedRepoType === 'Cloud'">
              @if(selectedRepoType === 'Cloud') {
              <ng-icon name="heroCheckSolid" size="14"></ng-icon>
              }
            </div>
          </div>
        </div>

        <!-- Local Storage Option -->
        <div class="storage-card" [class.active]="selectedRepoType === 'Local'" (click)="toggleButton('Local')">
          <div class="storage-icon local">
            <ng-icon name="phosphorHardDrive" size="28"></ng-icon>
          </div>
          <div class="storage-info">
            <span class="storage-label">Local Storage</span>
            <span class="storage-desc">Store securely on your device</span>
          </div>
          <div class="storage-check">
            <div class="check-circle" [class.checked]="selectedRepoType === 'Local'">
              @if(selectedRepoType === 'Local') {
              <ng-icon name="heroCheckSolid" size="14"></ng-icon>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cloud Storage Content -->
    @if(selectedRepoType === 'Cloud'){
    <div class="cloud-content">
      <p-tabs value="create" class="custom-tabs">
        <div class="flex justify-center w-full">
          <p-tablist class="flex flex-row">
            <p-tab value="create" class="bg-white!">Create Repository</p-tab>
            <p-tab value="connect" class="bg-white!">Existing Repositories</p-tab>
          </p-tablist>
        </div>

        <p-tabpanel value="create" class="tab-panel">
          <div class="form-group">
            <label class="form-label">Repository Name</label>
            <input type="text" class="form-input" placeholder="Enter a name for your repository"
              [(ngModel)]="cloudRepoName"
              (keyup.enter)="cloudRepoName.length && !isConnecting && newRepo(cloudRepoName, 'cloud', '')" />
          </div>
          <button class="primary-button" (click)="newRepo(cloudRepoName, 'cloud', '')"
            [disabled]="cloudRepoName.length === 0 || isConnecting">
            @if(isConnecting) {
            <div class="button-loading">
              <div class="spinner"></div>
              <span>Creating...</span>
            </div>
            } @else {
            <ng-icon name="heroPlus" size="18"></ng-icon>
            <span>Create Repository</span>
            }
          </button>
        </p-tabpanel>

        <p-tabpanel value="connect" class="tab-panel">
          <div class="form-group">
            <label class="form-label">Select Repository</label>
            <p-select [(ngModel)]="selectedRepo" [options]="cloudRepos" optionLabel="name"
              placeholder="Choose from your existing repositories" styleClass="custom-select bg-gray-100" appendTo="body">
            </p-select>
          </div>
          <button class="primary-button" [disabled]="selectedRepo === null || isConnecting"
            (click)="connectCloudExistingRepo(selectedRepo?.name || '', selectedRepo?.id || '')">
            @if(isConnecting) {
            <div class="button-loading">
              <div class="spinner"></div>
              <span>Connecting...</span>
            </div>
            } @else {
            <ng-icon name="heroLink" size="18"></ng-icon>
            <span>Connect</span>
            }
          </button>
        </p-tabpanel>
      </p-tabs>

      <!-- Success State -->
      @if(repoSelectionState?.type === 'cloud' && repoSelectionState?.state === 'repo_created'){
      <div class="status-card success">
        <div class="status-icon">
          <ng-icon name="heroCheckCircleSolid" size="32"></ng-icon>
        </div>
        <h3 class="status-title">Repository Created Successfully!</h3>
        <p class="status-message">Your repository <strong>{{ repo()?.name }}</strong> is ready to use.</p>
        <button class="success-button" (click)="onClose()">
          <ng-icon name="heroArrowRight" size="18"></ng-icon>
          <span>Start Working</span>
        </button>
      </div>
      }

      <!-- Error State -->
      @if(repoSelectionState?.type === 'cloud' && repoSelectionState?.state === 'repo_creation_failed'){
      <div class="status-card error">
        <div class="status-icon">
          <ng-icon name="heroXCircleSolid" size="32"></ng-icon>
        </div>
        <h3 class="status-title">Unable to Create Repository</h3>
        <p class="status-message">Please check your connection and try again.</p>
        <button class="error-button" (click)="onClose()">
          <ng-icon name="heroArrowPath" size="18"></ng-icon>
          <span>Try Again</span>
        </button>
      </div>
      }
    </div>
    }

    <!-- Local Storage Content -->
    @else if(selectedRepoType === 'Local'){
    <div class="local-content">
      <div class="form-group">
        <label class="form-label">Server URL</label>
        <div class="input-with-action">
          <input #serverUrl type="text" class="form-input" placeholder="Enter your local server URL"
            (keyup.enter)="localSubmitServerUrl(serverUrl.value)" />
          <button class="icon-button" (click)="localSubmitServerUrl(serverUrl.value)">
            <ng-icon name="heroArrowRight" size="20"></ng-icon>
          </button>
        </div>
        <p class="form-hint">Enter the URL where your repository will be stored locally</p>
      </div>

      <!-- Repo Exists -->
      @if (repoSelectionState?.type === 'local' && repoSelectionState?.state === 'repo_exists'){
      <div class="status-card info">
        <div class="status-icon">
          <ng-icon name="heroInformationCircleSolid" size="32"></ng-icon>
        </div>
        <h3 class="status-title">Repository Found</h3>
        <p class="status-message">Opening existing repository: <strong>{{ repo()?.name }}</strong></p>
        <button class="primary-button" (click)="onClose()">
          <ng-icon name="heroFolderOpen" size="18"></ng-icon>
          <span>Open Repository</span>
        </button>
      </div>
      }

      <!-- Create New Local -->
      @if (repoSelectionState?.type === 'local' && repoSelectionState?.state === 'repo_does_not_exist'){
      <div class="status-card info">
        <div class="status-icon">
          <ng-icon name="heroPlusCircleSolid" size="32"></ng-icon>
        </div>
        <h3 class="status-title">Create New Repository</h3>
        <p class="status-message">No repository found at this location. Create a new one.</p>
        <div class="inline-form">
          <input #repoName type="text" class="form-input" placeholder="Repository name"
            (keyup.enter)="newRepo(repoName.value, 'local', serverUrl.value)" />
          <button class="primary-button" (click)="newRepo(repoName.value, 'local', serverUrl.value)">
            <ng-icon name="heroPlus" size="18"></ng-icon>
            <span>Create</span>
          </button>
        </div>
      </div>
      }

      <!-- Local Success -->
      @if(repoSelectionState?.state === 'repo_created'){
      <div class="status-card success">
        <div class="status-icon">
          <ng-icon name="heroCheckCircleSolid" size="32"></ng-icon>
        </div>
        <h3 class="status-title">Repository Created!</h3>
        <p class="status-message">Your local repository is ready to use.</p>
        <button class="success-button" (click)="onClose()">
          <ng-icon name="heroArrowRight" size="18"></ng-icon>
          <span>Start Working</span>
        </button>
      </div>
      }

      <!-- Local Error -->
      @if(repoSelectionState?.state === 'repo_creation_failed'){
      <div class="status-card error">
        <div class="status-icon">
          <ng-icon name="heroXCircleSolid" size="32"></ng-icon>
        </div>
        <h3 class="status-title">Connection Failed</h3>
        <p class="status-message">Unable to connect. Please verify the server URL.</p>
        <button class="error-button" (click)="onClose()">
          <ng-icon name="heroArrowPath" size="18"></ng-icon>
          <span>Try Again</span>
        </button>
      </div>
      }
    </div>
    }
  </div>
</p-dialog>

<!-- Secondary Dialog (kept for compatibility) -->
<p-dialog [visible]="selectedRepoVisible" (visibleChange)="onClose()" styleClass="create-repo-dialog"
  [focusOnShow]="false" [draggable]="false" [dismissableMask]="true" [modal]="true" [resizable]="false"
  [closable]="true">
  <ng-template #header>
    <div class="dialog-header">
      <span class="dialog-title">Connect to Repository</span>
    </div>
  </ng-template>
  <div class="dialog-content compact">
    <p class="section-subtitle">Enter the server URL where your repository is hosted</p>
    <div class="form-group">
      <div class="input-with-action">
        <input #serverUrl type="text" class="form-input" placeholder="Server URL"
          (keyup.enter)="checkServerUrlValidity(serverUrl.value)" />
        <button class="icon-button" (click)="checkServerUrlValidity(serverUrl.value)">
          <ng-icon name="heroArrowRight" size="20"></ng-icon>
        </button>
      </div>
      <p class="form-hint">Make sure your server is running and accessible</p>
    </div>

    @if (repoSelectionState?.type === 'local' && repoSelectionState?.state === 'url_invalid'){
    <div class="status-card warning">
      <div class="status-icon">
        <ng-icon name="heroExclamationTriangleSolid" size="32"></ng-icon>
      </div>
      <h3 class="status-title">Different Repository Found</h3>
      <p class="status-message">This URL belongs to: <strong>{{ repo()?.name }}</strong></p>
      <button class="primary-button" (click)="onClose()">Open {{ repo()?.name }}</button>
    </div>
    }

    @if (repoSelectionState?.type === 'local' && repoSelectionState?.state === 'repo_id_mismatch'){
    <div class="status-card error">
      <div class="status-icon">
        <ng-icon name="heroXCircleSolid" size="32"></ng-icon>
      </div>
      <h3 class="status-title">Connection Error</h3>
      <p class="status-message">The server URL does not match the selected repository.</p>
      <button class="error-button" (click)="localSubmitServerUrl(serverUrl.value)">Connect Anyway</button>
    </div>
    }
  </div>
</p-dialog>